import React, { useState } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { TextField, Typography, Button, Grid, Box } from "@material-ui/core";
import SendIcon from "@material-ui/icons/Send";
import Navbar from "./Navbar";
import emailjs from "emailjs-com";

const useStyles = makeStyles((theme) => ({
  form: {
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    position: "absolute",
  },
  button: {
    marginTop: "1rem",
    color: "#32e0c4",
    borderColor: "grey",
    fontSize: "20px",
  },
}));

const InputField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "#32e0c4",
      background: "none",
      fontSize: "20px",
    },
    "& label": {
      color: "dark",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "dark",
      },
      "&:hover fieldset": {
        borderColor: "dark",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#213e3b",
      },
    },
  },
})(TextField);

const Contacts = () => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
  });
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    emailjs
      .send(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID,
        formData,
        process.env.REACT_APP_USER_ID
      )
      .then(() => {
        setSuccess(true);
        setLoading(false);
        setFormData({ name: "", email: "", company: "" });
        setTimeout(() => {
          setSuccess(false);
        }, 6000);
      })
      .catch(() => {
        setLoading(false);
        alert("Failed to send message, please try again.");
      });
  };

  console.log(formData);

  return (
    <Box component="div">
      <Navbar />
      <Grid container justify="center">
        <Box component="form" className={classes.form} onSubmit={handleSubmit}>
          <Typography
            variant="h5"
            style={{
              color: "#213e3b",
              textAlign: "center",
              fontSize: "29px",
              textTransform: "uppercase",
              fontFamily: "Quicksand",
            }}
          >
            Give Me Your Work And <br /> I'll Show Mine{" "}
            <span>
              <i className="fa fa-cog fa-spin"></i>
            </span>
          </Typography>
          <InputField
            fullWidth={true}
            label="Name"
            name="name"
            variant="outlined"
            margin="dense"
            size="medium"
            inputProps={{ style: { color: "#fff" } }}
            onChange={handleChange}
            value={formData.name}
            required
          />
          <br />
          <InputField
            fullWidth={true}
            label="Email"
            name="email"
            type="email"
            variant="outlined"
            margin="dense"
            size="medium"
            inputProps={{ style: { color: "#fff" } }}
            onChange={handleChange}
            value={formData.email}
            required
          />
          <br />
          <InputField
            fullWidth={true}
            label="Company Name"
            name="company"
            variant="outlined"
            margin="dense"
            size="medium"
            inputProps={{ style: { color: "#fff" } }}
            onChange={handleChange}
            value={formData.company}
            required
          />

          <br />

          <Button
            className={classes.button}
            variant="outlined"
            fullWidth
            type="submit"
            endIcon={<SendIcon />}
          >
            {loading ? "Sending..." : "Contact me"}
          </Button>
          {success && (
            <p
              style={{
                color: "#32e0c4",
                textAlign: "center",
                textTransform: "uppercase",
                fontFamily: "Quicksand",
              }}
            >
              Pukar Have Received Your Invitation, Replying Shortly!
            </p>
          )}
        </Box>
      </Grid>
    </Box>
  );
};

export default Contacts;
